import { Icon } from "@iconify/react";
import { Colors } from "../../../utils/colors";
import { MassTextsActionItem } from "../MassTexts/Items/MassTextsActionItem";
import { getProductDetails } from "../../../utils/productUtils";
import { ActionItemHorizontalDivider } from "../../Dividers/ActionItemHorizontalDivider";
import { EventType } from "@markit/common.types";

type SelectProductsListProps = {
  onItemPress: (eventType: EventType) => void;
  productTypesToDisplay: EventType[];
};

const SelectProductsList = (props: SelectProductsListProps) => {
  const { onItemPress, productTypesToDisplay } = props;

  return (
    <div className="ColumnNormal">
      {productTypesToDisplay.map((type) => (
        <div key={type}>
          <MassTextsActionItem
            title={getProductDetails(type).title}
            icon={
              <Icon
                icon={getProductDetails(type).icon}
                height={29}
                style={{ color: getProductDetails(type).color }}
              />
            }
            onPress={() => onItemPress(type)}
            alternateRightIcon={
              <Icon
                icon="ion:chevron-forward"
                height={22}
                style={{ color: Colors.GRAY1 }}
              />
            }
          />
          <ActionItemHorizontalDivider dividerMargin={7} />
        </div>
      ))}
    </div>
  );
};

export default SelectProductsList;
